import { render, staticRenderFns } from "./SelectSolution.vue?vue&type=template&id=ba08bb04&"
import script from "./SelectSolution.vue?vue&type=script&lang=js&"
export * from "./SelectSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports